import * as React from "react";
import {Fragment, Component, PureComponent} from "react";
import Aside from "../Aside/Aside";
import FetchData from "../../backend/FetchData";
import Spinner from "../Process/Spinner";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

export default class BackgroundUpload extends Component {

	constructor(props) {
		super(props);
		this.state = {
			uploading: false,
			// uploadedFile: false
		}
		// this.onSubmit = this.onSubmit.bind(this);
		this.uploading = this.uploading.bind(this);
	}

	// onSubmit(ev) {
	// 	ev.preventDefault();
	// 	console.log('form submit');
	//
	// 	let data = new FormData();
	// 	data.append('file[]', document.getElementById('upload').files[0]);
	//
	// 	let requestOptions = {
	// 		method: 'POST',
	// 		redirect: 'follow'
	// 	};
	//
	// 	const requestHeaders = new Headers();
	// 	const csrfToken = document.getElementById('root').dataset.csrf;
	// 	requestHeaders.append('X-Flow-Csrftoken', csrfToken);
	// 	requestOptions.headers = requestHeaders;
	// 	requestOptions.body = data;
	//
	// 	this.setState({uploading: true}, () => {
	// 		fetch('/api/file/upload', requestOptions)
	// 			.then((response) => response && response.json()).then(result => {
	// 			console.log(result);
	// 			this.setState({uploading: false});
	// 			this.setState({uploadedFile: result[0]}, () => {
	// 				console.log(this.state.uploadedFile)
	// 				this.props.setBackground(this.state.uploadedFile);
	//
	// 			});
	// 		}).catch(error => console.log('error', error));
	// 	})
	//
	// }

	uploading(state) {
		this.setState({uploading: state});
	}

	render() {

		const {uploading} = this.state;

		return (
			<Fragment>
				<Aside title="Hintergrundbild-Einstellungen">
					<ImageCropper uploading={(p) => this.uploading(p)}/>
					{uploading &&
						<div className="d-flex align-items-center text-center justify-content-center mt-4">
							<Fragment>
								<Spinner style="rotate" />
								<span className="ms-3 text-primary">
									 Das Bild wird verarbeitet ...
								</span>
							</Fragment>
						</div>
					}
				</Aside>
			</Fragment>
		);
	}
}

class ImageCropper extends PureComponent {
	state = {
		src: null,
		crop: {
			unit: "%",
			x: 0,
			y: 0,
			width: 50,
			height: 50
		},
		hasBackground: false,
		changed: false,
	};

	onSelectFile = e => {
		if (e.target.files && e.target.files.length > 0) {
			const {uploading} = this.props;
			uploading(true);
			const reader = new FileReader();
			reader.addEventListener('load', () =>
				this.setState({ src: reader.result })
			);
			reader.readAsDataURL(e.target.files[0]);
		}
	};

	onImageLoaded = image => {
		this.imageRef = image;
	};

	onCropComplete = crop => {
		this.makeClientCrop(crop);
	};

	onCropChange = (crop, percentCrop) => {
		this.setState({ crop });
	};

	async makeClientCrop(crop) {
		const {hasBackground} = this.state;
		if(hasBackground) {
			this.setState({changed: true});
		}
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(
				this.imageRef,
				crop,
				'newFile.jpeg'
			);
			this.setState({ croppedImageUrl });
		}
	}

	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement("canvas");
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = crop.width * scaleX;
		canvas.height = crop.height * scaleY;
		const ctx = canvas.getContext("2d");

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY
		);

		return new Promise((resolve, reject) => {
			const {uploading} = this.props;
			canvas.toBlob(blob => {
				if (!blob) {
					console.error('Canvas is empty');
					uploading(false);
					return;
				}
				blob.name = fileName;
				window.URL.revokeObjectURL(this.fileUrl);
				this.fileUrl = window.URL.createObjectURL(blob);
				resolve(this.fileUrl);
				uploading(false);
			}, 'image/jpeg');
		});
	}

	removeImage = () => {
		const checkBackground = document.getElementById('check-background');
		checkBackground.checked = false;
		const modelFrame = document.getElementById('modelFrame');
		modelFrame.style.backgroundImage = 'none';
		this.setState({hasBackground: false}, () => {
			this.setState({changed: false});
		});
	}

	componentDidMount() {
		const checkBackground = document.getElementById('check-background');
		if(checkBackground.checked) {
			// console.log('is checked');
			this.setState({hasBackground: true});
		}
	}

	render() {

		const {crop, croppedImageUrl, src, hasBackground, changed} = this.state;

		const useCroppedImageAsBackground = () => {
			const checkBackground = document.getElementById('check-background');
			if(!checkBackground.checked) {
				checkBackground.click();
			}
			const imageSrc = document.getElementById('croppedImage').src;
			const modelFrame = document.getElementById('modelFrame');
			modelFrame.style.backgroundImage = `url('${imageSrc}')`;
			this.setState({hasBackground: true});
		}

		return (
			<Fragment>
				{src && (
					<ReactCrop
						src={src}
						crop={crop}
						ruleOfThirds
						onImageLoaded={this.onImageLoaded}
						onComplete={this.onCropComplete}
						onChange={this.onCropChange}
					/>
				)}
				{croppedImageUrl && (
					<img id="croppedImage" alt="" style={{ maxWidth: "100%" }} src={croppedImageUrl} className="d-none" />
				)}
				<div className="d-block">
					{src &&
						<Fragment>
							<button type="button" className="btn btn-success d-block w-100" onClick={useCroppedImageAsBackground}>{changed ? `Veränderten Ausschnitt anwenden` : `Diesen Ausschnitt verwenden`}</button>
							<span className="d-block mt-3 mb-2">Wenn Sie ein anderes Bild verwenden wollen, wählen Sie einfach ein Neues aus.</span>
						</Fragment>
					}
					{!hasBackground && !src &&
						<Fragment>
							<p>Laden Sie ein eigenes Hintergrundbild Ihres Hauses hoch, um eine bessere Vorstellung zu bekommen, wie Ihre Markise aussehen könnte.</p>
							<p>Achten Sie für ein perfektes Ergebnis bitte darauf, ein Bild des Hauses zu wählen, welches möglichst gerade und normal zur Kamera aufgenommen wurde.</p>
						</Fragment>
					}
					{!hasBackground &&
						<input type="file" className="form-control" accept="image/*" onChange={this.onSelectFile} />
					}
					{hasBackground &&
						<button type="button" className="btn btn-outline-danger d-block w-100" onClick={this.removeImage}>Aktuelles Hintergrundbild entfernen</button>
					}
				</div>
			</Fragment>
		);
	}
}
